/**
 * 대여규정 관련 공통 고지 문구.
 *
 * 회사 대여규정 본문(companyData.rentalRules)은 ERP DB에서 내려오기 때문에
 * 프론트에서 수정할 수 없다. 차급별 추가 대여 자격처럼 DB 본문에 빠져 있는
 * 고지는 이 상수로 관리해 대여규정이 노출되는 모든 화면에 동일하게 붙인다.
 */

/** 슈퍼카·쏠라티 추가 대여 자격(연령/운전경력) 고지 */
export const SUPERCAR_RENTAL_AGE_NOTICE =
  '단, 슈퍼카·쏠라티는 만 30세 이상, 운전경력 3년 이상이어야 대여 가능합니다.';
